import React, { useRef } from 'react'
import { IMask } from 'react-imask/dist/react-imask'
import _ from 'lodash'
import { ADDITIONAL_FORM_FIELD_PROPS, COMMON_FORM_FIELD_PROPS, FORM_FIELD_CONTROL_PROPS } from './FORM_FIELD_PROP_TYPES'
import { Icon, Popup } from 'semantic-ui-react'

const Input = ({
  id,
  label,
  attachedLabel,
  onFocus,
  onChange,
  onBlur,
  viewValue,
  value,
  invalid,
  error,
  disabled,
  detail,
  maxLength,
  minLength,
  className,
  maskOptions,
  hoverDetail
}) => {

  const inputRef = useRef(null)
  const mask = useRef(maskOptions ? IMask.createMask({
    ...maskOptions.additionalProps,
    mask: maskOptions.isNumber ? Number : maskOptions.pattern
  }) : undefined)

  const fieldClass = () => {
    return [
      'Field',
      (disabled) && 'is-disabled',
      (invalid) && 'is-invalid',
      (invalid && !error) && 'Field--hide-error'
    ]
      .filter(Boolean)
      .join(' ')
  }

  const labelElement = () => {
    const labelContent = hoverDetail ? <>{label}&nbsp;<Icon name='info circle' /></> : label
    return typeof label === 'string' ?
      <label htmlFor={id || label} className='Field-label'>{labelContent}</label> : (
        label ? React.cloneElement(label, { className: 'Field-label' }) : <></>
      )
  }

  const onChangeWrapper = (e) => {
    e.target.value = e.target.value.trimStart()
    onChange(e)
  }

  const inputElementProps = {
    onChange: (e) => onChangeWrapper(e),
    onBlur: (e) => onBlur(e),
    value: viewValue || value,
    maxLength: maxLength,
    minLength: minLength,
    disabled: disabled,
    'data-testid': id,
    ...(onFocus && { onFocus: (e) => onFocus(e) }),
    ...(detail && { 'aria-describedby': `${id}--detail` }),
  }

  const onMaskedInputChange = (e) => {
    onChange({ target: { value: mask?.current?.resolve(e.target.value) } })
  }

  const textInputDetail = () => {
    return <span
      className='Field-detail'
      id={id + '--detail'}
      data-testid={id + '--detail'}
    >
      {detail}
    </span>
  }

  const textInputErrorDetail = () => {
    return <span className='Field-error' id={id + '--error'} data-testid={id + '--error'}>
      {value.length === 0 ? 'Required' : error}
    </span>
  }

  const textInput = (inputClass) => {
    return <input
      ref={inputRef}
      id={id}
      type='text'
      className={`${inputClass}${className ? ` ${className}` : ''}`}
      {...inputElementProps}
      {...maskOptions && {
        onChange: onMaskedInputChange,
        placeholder: maskOptions && !maskOptions.isNumber ? maskOptions.pattern.replace(/0/g, '_') : ''
      }}
    />
  }

  return <div className={fieldClass()}>
    {hoverDetail ?
      <Popup content={hoverDetail} trigger={labelElement()} /> :
      labelElement()
    }
    {attachedLabel ?
      <div className={`${fieldClass()} -inline`}>
        <div className='Field-label -inline'>
          {attachedLabel}
        </div>
        {textInput('Input -inline')}
      </div> :
      textInput('Input')
    }
    {detail && textInputDetail()}
    {invalid && textInputErrorDetail()}
  </div>
}

Input.propTypes = {
  ...FORM_FIELD_CONTROL_PROPS,
  ...ADDITIONAL_FORM_FIELD_PROPS,
  ..._.omit(COMMON_FORM_FIELD_PROPS, ['inputType', 'options', 'placeholder', 'transform']),
}

export default Input